import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MapPin } from 'lucide-react';
const POPUPS = [{
  name: 'Camila',
  location: 'Buenos Aires, Argentina',
  time: 'Hace 5 minutos'
}, {
  name: 'Matías',
  location: 'Santiago, Chile',
  time: 'Hace 12 minutos'
}, {
  name: 'Valentina',
  location: 'Bogotá, Colombia',
  time: 'Hace 23 minutos'
}, {
  name: 'Mateo',
  location: 'Lima, Perú',
  time: 'Hace 45 minutos'
}, {
  name: 'Sofía',
  location: 'Montevideo, Uruguay',
  time: 'Hace 1 hora'
}, {
  name: 'Lucas',
  location: 'CDMX, México',
  time: 'Hace 2 horas'
}, {
  name: 'Florencia',
  location: 'Córdoba, Argentina',
  time: 'Hace 3 horas'
}, {
  name: 'Daniela',
  location: 'Guayaquil, Ecuador',
  time: 'Hace 4 horas'
}];
export function SocialProofPopup() {
  const [currentIndex, setCurrentIndex] = useState<number | null>(null);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    // Initial delay before showing first popup
    const initialTimer = setTimeout(() => {
      showNextPopup();
    }, 5000);
    return () => clearTimeout(initialTimer);
  }, []);
  const showNextPopup = () => {
    // Pick a random popup
    const randomIndex = Math.floor(Math.random() * POPUPS.length);
    setCurrentIndex(randomIndex);
    setIsVisible(true);
    // Hide after 4 seconds
    setTimeout(() => {
      setIsVisible(false);
      // Schedule next popup between 10 and 25 seconds
      const nextDelay = Math.floor(Math.random() * 15000) + 10000;
      setTimeout(() => {
        showNextPopup();
      }, nextDelay);
    }, 4000);
  };
  return <div className="fixed bottom-24 md:bottom-4 left-4 right-4 md:right-auto z-30 pointer-events-none max-w-xs" aria-live="polite" data-id="element-2">
      <AnimatePresence data-id="element-3">
        {isVisible && currentIndex !== null && <motion.div initial={{
        opacity: 0,
        y: 50,
        scale: 0.9
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.9
      }} transition={{
        type: 'spring',
        stiffness: 400,
        damping: 25
      }} className="bg-white rounded-xl shadow-lg border border-travertino/20 p-3 flex items-center gap-3 pr-6" data-id="element-4">
            <div className="w-10 h-10 rounded-full bg-caribe/10 flex items-center justify-center shrink-0" data-id="element-5">
              <MapPin className="text-caribe" size={20} data-id="element-6" />
            </div>
            <div data-id="element-7">
              <p className="text-sm text-oceano" data-id="element-8">
                <span className="font-semibold" data-id="element-9">
                  {POPUPS[currentIndex].name}
                </span>{' '}
                de {POPUPS[currentIndex].location}
              </p>
              <p className="text-xs text-hierro font-medium" data-id="element-10">
                Compró el Método Volar en Calma
              </p>
              <p className="text-[10px] text-hierro/70 mt-0.5" data-id="element-11">
                {POPUPS[currentIndex].time}
              </p>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}